import React, {useEffect, useState} from "react";
import {styled} from "@mui/material/styles";
import Tooltip, {tooltipClasses} from "@mui/material/Tooltip";
import {Button} from "@material-ui/core";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Slide from "@mui/material/Slide";
import {ErrorMessage, Field, Form, Formik} from "formik";
import {basicSchema} from "../schemas/Schemas";
import {motion} from "framer-motion";
import LoadingButton from "@mui/lab/LoadingButton";
import TextField from "@mui/material/TextField";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DesktopDatePicker} from "@mui/x-date-pickers/DesktopDatePicker";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import RichTextEditor from "../RichTextEditor/RichTextEditor";
import EditorState from "draft-js/lib/EditorState";
import {convertToRaw} from "draft-js";
import draftToHtml from "draftjs-to-html";
import CryptoJS from "crypto-js";
import {dateSchema} from "../schemas/Schemas";
import {
    AccountBalanceWallet,
    Apartment,
    Assignment,
    Payment,
    Warning,
    Send,
    Delete,
    CheckCircle,
    Cancel,
    Info
} from '@mui/icons-material';
import {ApiDetails, KEY} from "../../dummyData";

// Transition component for dialogs
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// Styled tooltip component
const HtmlTooltip = styled(({className, ...props}) => (
    <Tooltip {...props} classes={{popper: className}}/>
))(({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#ffffff",
        color: "rgba(0, 0, 0, 0.87)",
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: "1px solid #dadde9",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        padding: "12px 16px",
        borderRadius: "8px"
    },
}));

export default function FeaturedInfoModern(props) {
    // Decrypt tenant details from localStorage
    let details = CryptoJS.AES.decrypt(
        localStorage.getItem("tenant_details"),
        KEY
    );

    let originalText = details.toString(CryptoJS.enc.Utf8);

    // State variables
    const [detailsSet, setDetailsSet] = useState(false);
    const [backDrop, setBackDrop] = useState(
        <Backdrop
            sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
            open={true}
        >
            <CircularProgress color="inherit"/>
        </Backdrop>
    );

    const [tenantDetails, setTenantDetails] = useState(
        new Map(
            Object.entries({
                tenant_id: "",
                first_name: "",
                last_name: "",
                national_id: "",
                email_address: "",
                phone_number: "",
                house_number: "",
                rent: "",
                bill: "",
                arrears: "",
                account_balance: "",
                amount: "",
                state: "",
                temp_account_balance: "",
                minimum_days_to_vacate: "",
                date_created: "",
                Wallet: "",
                status: "",
                property_name: "",
            })
        )
    );

    const [warningModal, setWarningModal] = useState(false);
    const [paymentModal, setPaymentModal] = useState(false);
    const [vacatingNoticeModal, setVacatingNoticeModal] = useState(false);
    // New state for recall reason modal
    const [recallReasonModal, setRecallReasonModal] = useState(false);
    const [recallReason, setRecallReason] = useState("");

    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const [dateToday] = useState(new Date());
    const [dateToVacate, setDateToVacate] = useState(new Date());
    const [tenantLoading, setTenantLoading] = useState(false);
    const [valuesAfterWarning, setValuesAfterWarning] = useState({});
    const [vacatingWarningModalNotice, setVacatingWarningModalNotice] = useState("");

    // Initial values for forms
    const initialPaymentValues = {
        amount: tenantDetails.get("status") === "COMPLETED" ? 0 : tenantDetails.get("Wallet"),
        phone_number: tenantDetails.get("phone_number"),
    };

    const initialValues2 = {
        first_name: tenantDetails.get("first_name"),
        last_name: tenantDetails.get("last_name"),
        phone_number: tenantDetails.get("phone_number"),
        national_id: tenantDetails.get("national_id"),
        unit: tenantDetails.get("house_number"),
        property_name: tenantDetails.get("property_name"),
        landlord_id: tenantDetails.get("landlord_id"),
        tenant_id: tenantDetails.get("tenant_id"),
    };

    useEffect(() => {
        fetchTenantDetails();
    }, []);

    const fetchTenantDetails = () => {
        setBackDrop(
            <Backdrop
                sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
                open={true}
                onClick={null}
            >
                <CircularProgress color="inherit"/>
            </Backdrop>
        );
        fetch(ApiDetails + "pegasus/visionary/tenant/app/tenantDetails", {
            method: "POST",
            headers: {
                "token": new Map(
                    Object.entries(JSON.parse(originalText))
                ).get("access_token"),
            },
            body: JSON.stringify({
                tenant_id: new Map(
                    Object.entries(JSON.parse(originalText))
                ).get("tenant_id"),
            }),
        })
            .then(async (response) => {
                let data = await response.json();
                if (response.status === 200) {
                    setTenantDetails(new Map(Object.entries(data)));

                    console.log("tenantDetails");
                    console.log(data);

                    setDetailsSet(true);
                    setBackDrop(<></>);
                } else if (response.status === 401) {
                    props.snackBar({
                        text: "Maximum concurrent logins reached",
                        type: "warning",
                    });
                } else if (response.status === 400) {
                    props.snackBar({
                        text: "Invalid Credentials Provided.",
                        type: "error",
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                props.snackBar({
                    text: "Something Went Wrong. Try Again Later",
                    type: "error",
                });
            });
    };

    const processPayment = async (values) => {
        setTenantLoading(true);

        if (values.phone_number.toString().startsWith("0")) {
            values.phone_number = "254" + values.phone_number.toString().substring(1);
        } else if (
            values.phone_number.toString().startsWith("1") ||
            values.phone_number.toString().startsWith("7")
        ) {
            values.phone_number = "254" + values.phone_number.toString();
        }

        if (
            tenantDetails.get("ho_number") === 0 ||
            tenantDetails.get("till_number") === 0 ||
            tenantDetails.get("short_code") === "" ||
            tenantDetails.get("pass_key") === ""
        ) {
            props.snackBar({
                text: "Payment details have not been set for your property",
                type: "error",
            });
            setTenantLoading(false);
            handleClose();
            return;
        }

        let body = {
            BusinessShortCode: tenantDetails.get("ho_number").toString(),
            Password: "",
            Timestamp: "",
            TransactionType: "CustomerBuyGoodsOnline",
            Amount: values.amount,
            PartyA: values.phone_number,
            PartyB: tenantDetails.get("till_number").toString(),
            PhoneNumber: values.phone_number,
            CallBackURL:
                "https://api.pegasus-pms.co.ke/api/" + "pegasus/visionary/payments/",
            AccountReference: "ITORAMA SOLUTIONS",
            TransactionDesc: "Payment of rent",
            houseNumber: tenantDetails.get("account_number"),
            tenant_id: tenantDetails.get("tenant_id"),
            landlord_id: tenantDetails.get("landlord_id"),
            short_code: tenantDetails.get("short_code"),
            pass_key: tenantDetails.get("pass_key"),
            consumer_key: tenantDetails.get("consumer_key"),
            consumer_secret: tenantDetails.get("consumer_secret"),
        };

        fetch(ApiDetails + "pegasus/visionary/mpesa/StkPush", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": new Map(
                    Object.entries(JSON.parse(originalText))
                ).get("access_token"),
            },
            body: JSON.stringify(body),
        })
            .then(async (response) => {
                let data = await response.json();

                // Handle authentication/authorization issues first
                if (response.status === 403) {
                    // Check if it's a session expiry or duplicate transaction
                    if (data.Message && data.Message.includes("ongoing transaction")) {
                        setTenantLoading(false);
                        props.snackBar({
                            text: data.Message,
                            type: "warning",
                        });
                    } else {
                        // Session expired - redirect to login
                        localStorage.clear();
                        window.location.href = "/";
                        return;
                    }
                }
                // Success - STK Push initiated successfully
                else if (response.status === 200) {
                    setTenantLoading(false);
                    if (data.success) {
                        props.snackBar({
                            text: "Payment request sent! Check your phone for M-Pesa prompt.",
                            type: "success",
                        });
                    } else {
                        // Fallback for successful response without success flag
                        props.snackBar({
                            text: "Kindly wait for M-Pesa prompt on your phone",
                            type: "success",
                        });
                    }
                }
                // Bad Request - M-Pesa validation errors
                else if (response.status === 400) {
                    setTenantLoading(false);
                    let errorMessage = "Payment request failed";

                    // Handle both error formats
                    if (data.userMessage) {
                        // Backend provided user-friendly message
                        errorMessage = data.userMessage;
                    } else if (data.errorMessage) {
                        // New error format (errorCode/errorMessage)
                        errorMessage = data.errorMessage;
                    } else if (data.ResponseDescription) {
                        // Original format (ResponseCode/ResponseDescription)
                        const responseDesc = data.ResponseDescription.toLowerCase();
                        if (responseDesc.includes("insufficient funds")) {
                            errorMessage = "💳 Insufficient funds in your M-Pesa account";
                        } else if (responseDesc.includes("minimum transaction")) {
                            errorMessage = "⬇️ Amount is below minimum transaction limit";
                        } else if (responseDesc.includes("maximum transaction")) {
                            errorMessage = "⬆️ Amount exceeds maximum transaction limit";
                        } else if (responseDesc.includes("daily transfer limit")) {
                            errorMessage = "📊 Daily transfer limit exceeded";
                        } else if (responseDesc.includes("duplicate")) {
                            errorMessage = "🔄 Duplicate transaction detected";
                        } else if (responseDesc.includes("invalid")) {
                            errorMessage = "❌ Invalid account or phone number";
                        } else {
                            errorMessage = data.ResponseDescription;
                        }
                    } else if (data.Error) {
                        errorMessage = data.Error;
                    }

                    props.snackBar({
                        text: errorMessage,
                        type: "error",
                    });
                }
                // Unauthorized - Authentication/authorization issues with M-Pesa
                else if (response.status === 401) {
                    setTenantLoading(false);
                    let errorMessage = "🔐 Authentication error with payment service";

                    // Handle specific credential errors
                    if (data.errorCode === "500.001.1001" || data.errorMessage?.toLowerCase().includes("wrong credentials")) {
                        errorMessage = "🔐 Invalid M-Pesa credentials. Please contact system administrator.";
                    } else if (data.userMessage) {
                        errorMessage = data.userMessage;
                    } else if (data.errorMessage) {
                        errorMessage = data.errorMessage;
                    }

                    props.snackBar({
                        text: errorMessage,
                        type: "error",
                    });
                }
                // Request Timeout - User cancelled or timeout
                else if (response.status === 408) {
                    setTenantLoading(false);
                    props.snackBar({
                        text: "Payment request timed out or was cancelled",
                        type: "warning",
                    });
                }
                // Internal Server Error
                else if (response.status === 500) {
                    setTenantLoading(false);
                    props.snackBar({
                        text: "Server error occurred. Please try again later.",
                        type: "error",
                    });
                }
                // Bad Gateway - M-Pesa service issues
                else if (response.status === 502) {
                    setTenantLoading(false);
                    props.snackBar({
                        text: "M-Pesa service is currently unavailable. Please try again later.",
                        type: "error",
                    });
                }
                // Handle any other status codes
                else {
                    setTenantLoading(false);
                    const errorMessage = data.Error || data.Message || "Payment request failed";
                    props.snackBar({
                        text: errorMessage,
                        type: "error",
                    });
                }

                handleClose();
            })
            .catch((err) => {
                console.error("STK Push Error:", err);
                setTenantLoading(false);

                // Handle network errors
                if (err.name === 'TypeError' && err.message.includes('fetch')) {
                    props.snackBar({
                        text: "Network error. Please check your connection and try again.",
                        type: "error",
                    });
                } else {
                    props.snackBar({
                        text: "Payment request failed. Please try again.",
                        type: "error",
                    });
                }

                handleClose();
            });

        // fetchTenantDetails();
    };

    // Helper function to convert month number to name
    function toMonthName(monthNumber) {
        const date = new Date();
        date.setMonth(monthNumber);
        return date.toLocaleString("en-US", {month: "long"});
    }

    // Checklist validation function
    const getVacatingChecklist = () => {
        const checklist = [];
        const today = new Date();
        const vacateDate = new Date(dateToVacate);
        const dateJoined = new Date(tenantDetails.get("date_created").toString());
        const minimumMonths = tenantDetails.get("minimum_days_to_vacate");

        // Calculate months difference
        const monthsDifference =
            vacateDate.getFullYear() * 12 + vacateDate.getMonth() -
            (dateJoined.getFullYear() * 12 + dateJoined.getMonth());

        // Calculate days until vacating
        const daysUntilVacating = Math.ceil((vacateDate - today) / (1000 * 60 * 60 * 24));

        // 1. Notice timing (before 5th of month)
        checklist.push({
            id: 'notice_timing',
            title: 'Notice Given Before 5th of Month',
            description: 'Notice should be given before the 5th to avoid deposit forfeiture risk',
            status: today.getDate() <= 5 ? 'passed' : 'warning',
            risk: today.getDate() > 5 ? 'May risk deposit forfeiture' : null
        });

        // 2. Minimum stay period
        checklist.push({
            id: 'minimum_stay',
            title: `Minimum Stay Period (${minimumMonths} months)`,
            description: `You must stay for at least ${minimumMonths} months to qualify for deposit refund`,
            status: monthsDifference >= minimumMonths ? 'passed' : 'warning',
            risk: monthsDifference < minimumMonths ? 'Deposit will not be refunded' : null
        });

        // 3. Outstanding bills
        const hasOutstandingBills = tenantDetails.get("status") !== "COMPLETED";
        checklist.push({
            id: 'outstanding_bills',
            title: 'Clear All Outstanding Bills',
            description: 'All rent and utility bills must be paid before vacating',
            status: !hasOutstandingBills ? 'passed' : 'failed',
            risk: hasOutstandingBills ? 'Must clear all bills before vacating' : null
        });

        // 4. One month notice period
        checklist.push({
            id: 'notice_period',
            title: 'One Month Notice Period',
            description: 'Give at least 30 days notice before vacating',
            status: daysUntilVacating >= 30 ? 'passed' : 'warning',
            risk: daysUntilVacating < 30 ? 'Short notice may affect deposit refund' : null
        });

        // 5. End of month vacating
        const vacateDay = vacateDate.getDate();
        checklist.push({
            id: 'end_of_month',
            title: 'Vacate at End of Month',
            description: 'Vacating should occur between 28th-31st of the month',
            status: vacateDay >= 28 ? 'passed' : 'warning',
            risk: vacateDay < 28 ? 'May incur additional charges for partial month' : null
        });

        // 6. Property condition (informational)
        checklist.push({
            id: 'property_condition',
            title: 'Property in Good Condition',
            description: 'Ensure property has no damages beyond normal wear and tear',
            status: 'info',
            risk: null
        });

        // 7. Key return (informational)
        checklist.push({
            id: 'key_return',
            title: 'Return All Keys & Access Cards',
            description: 'All keys and access cards must be returned on vacating day',
            status: 'info',
            risk: null
        });

        // 8. Forwarding address (informational)
        checklist.push({
            id: 'forwarding_address',
            title: 'Provide Forwarding Address',
            description: 'Provide valid address for deposit refund communication',
            status: 'info',
            risk: null
        });

        return checklist;
    };

    // Send vacating notice function with API call
    const sendVacatingNotice = (values) => {
        setTenantLoading(true);

        // Get minimum months before vacating
        let minimumMonthsBeforeVacating = tenantDetails.get("minimum_days_to_vacate");

        // Calculate difference in months
        let dateJoined = new Date(tenantDetails.get("date_created").toString());
        let vacatingDate = new Date(dateToVacate.toJSON());
        let difference =
            vacatingDate.getFullYear() * 12 +
            vacatingDate.getMonth() -
            (dateJoined.getFullYear() * 12 + dateJoined.getMonth());

        // Prepare values for API
        const apiValues = {
            first_name: tenantDetails.get("first_name"),
            last_name: tenantDetails.get("last_name"),
            phone_number: tenantDetails.get("phone_number"),
            national_id: tenantDetails.get("national_id"),
            unit: tenantDetails.get("house_number"),
            property_name: tenantDetails.get("property_name"),
            landlord_id: tenantDetails.get("landlord_id"),
            tenant_id: tenantDetails.get("tenant_id"),
            date_to_vacate_house:
                toMonthName(new Date(dateToVacate.toJSON()).getMonth()) +
                " " +
                new Date(dateToVacate.toJSON()).getDate() +
                ", " +
                new Date(dateToVacate.toJSON()).getFullYear(),
            date_notice_given: new Date(),
            reasons_for_vacating: JSON.stringify(
                convertToRaw(editorState.getCurrentContent())
            ),
            landlord_notice: true,
        };

        // Validate vacating date
        if (difference < minimumMonthsBeforeVacating) {
            setValuesAfterWarning(apiValues);
            handleClose();
            setVacatingWarningModalNotice(
                "Please note that you need to have occupied the premises for at least " +
                minimumMonthsBeforeVacating +
                " months to qualify for refund of deposit.\nIf you " +
                "proceed, your deposit shall not be refunded"
            );
            setWarningModal(true);
            setTenantLoading(false);
            return;
        } else if (
            new Date(dateToVacate.toJSON()).getFullYear() < dateToday.getFullYear()
        ) {
            props.snackBar({
                text: "Invalid date to vacate.",
                type: "error",
            });
            setTenantLoading(false);
            return;
        } else if (
            new Date(dateToVacate.toJSON()).getFullYear() === dateToday.getFullYear() &&
            new Date(dateToVacate.toJSON()).getMonth() < dateToday.getMonth()
        ) {
            props.snackBar({
                text: "Invalid date to vacate.",
                type: "error",
            });
            setTenantLoading(false);
            return;
        } else if (
            new Date(dateToVacate.toJSON()).getDate() < 28 &&
            new Date(dateToVacate.toJSON()).getMonth() === dateToday.getMonth()
        ) {
            setValuesAfterWarning(apiValues);
            handleClose();
            setVacatingWarningModalNotice(
                "Notice to vacate are given one month in advance.\nIf you " +
                "proceed, you risk not being refunded your deposit"
            );
            setWarningModal(true);
            setTenantLoading(false);
            return;
        } else if (
            dateToday.getDate() >= 3 &&
            new Date(dateToVacate.toJSON()).getMonth() === dateToday.getMonth()
        ) {
            setValuesAfterWarning(apiValues);
            handleClose();
            setVacatingWarningModalNotice(
                "Notice to vacate are given before the 3rd of the month.\nIf you " +
                "proceed, you risk not being refunded your deposit"
            );
            setWarningModal(true);
            setTenantLoading(false);
            return;
        } else if (new Date(dateToVacate.toJSON()).getDate() < 28) {
            props.snackBar({
                text: "You can only vacate property at the end of the month",
                type: "error",
            });
            setTenantLoading(false);
            return;
        } else {
            // Make API call to submit notice
            fetch(ApiDetails + "pegasus/visionary/tenant/app/AddNotice", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": new Map(
                        Object.entries(JSON.parse(originalText))
                    ).get("access_token"),
                },
                body: JSON.stringify(apiValues),
            })
                .then(async (response) => {
                    if (response.status === 200) {
                        props.snackBar({
                            text: "Notice uploaded successfully.",
                            type: "success",
                        });
                        setTenantLoading(false);
                        handleClose();
                        fetchTenantDetails(); // Refresh tenant details
                    } else {
                        setTenantLoading(false);
                        handleClose();
                        props.snackBar({
                            text: "Something went wrong. Kindly try again later.",
                            type: "error",
                        });
                    }
                })
                .catch((err) => {
                    setTenantLoading(false);
                    handleClose();
                    console.log(err);
                    props.snackBar({
                        text: "Something went wrong. Kindly try again later.",
                        type: "error",
                    });
                });
        }
    };

    // Send vacating notice after warning with API call
    const sendVacatingNoticeAfterWarning = () => {
        setTenantLoading(true);

        fetch(ApiDetails + "pegasus/visionary/tenant/app/AddNotice", {
            method: "POST",
            headers: {
                "token": new Map(
                    Object.entries(JSON.parse(originalText))
                ).get("access_token"),
                "Content-Type": "application/json",
            },
            body: JSON.stringify(valuesAfterWarning),
        })
            .then(async (response) => {
                if (response.status === 200) {
                    props.snackBar({
                        text: "Notice uploaded successfully.",
                        type: "success",
                    });
                    setTenantLoading(false);
                    handleClose();
                    fetchTenantDetails(); // Refresh tenant details
                } else {
                    setTenantLoading(false);
                    handleClose();
                    props.snackBar({
                        text: "Something went wrong. Kindly try again later.",
                        type: "error",
                    });
                }
            })
            .catch((err) => {
                setTenantLoading(false);
                handleClose();
                console.log(err);
                props.snackBar({
                    text: "Something went wrong. Kindly try again later.",
                    type: "error",
                });
            });
    };

    // Updated Delete/Recall notice function with reason
    const deleteNotice = (id, reason) => {
        setTenantLoading(true);

        fetch(
            ApiDetails +
            "pegasus/visionary/authorization/admin/delete/specific/tenant/notices",
            {
                method: "POST",
                headers: {
                    "token": new Map(
                        Object.entries(JSON.parse(originalText))
                    ).get("access_token"),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: id,
                    tenant_id: tenantDetails.get("tenant_id"),
                    recall_reason: reason
                }),
            }
        )
            .then(async (response) => {
                let data = await response.json();
                if (response.status === 200) {
                    props.snackBar({
                        text: "Notice recalled successfully.",
                        type: "success",
                    });
                    setTenantLoading(false);
                    handleClose();
                    fetchTenantDetails(); // Refresh tenant details
                } else {
                    setTenantLoading(false);
                    props.snackBar({
                        text: "Something went wrong. Kindly try again later.",
                        type: "error",
                    });
                }
            })
            .catch((error) => {
                console.error("Error deleting notice:", error);
                setTenantLoading(false);
                props.snackBar({
                    text: "Something went wrong. Kindly try again later.",
                    type: "error",
                });
            });
    };

    // Handle recall notice button click
    const handleRecallNoticeClick = () => {
        setRecallReasonModal(true);
    };

    // Handle recall reason submission
    const handleRecallReasonSubmit = () => {
        if (!recallReason.trim()) {
            props.snackBar({
                text: "Please provide a reason for recalling the notice.",
                type: "error",
            });
            return;
        }

        const noticeId = new Map(Object.entries(tenantDetails.get("notice") || {})).get("id");
        if (noticeId) {
            deleteNotice(noticeId, recallReason);
        }
    };

    // Dialog close handler
    const handleClose = () => {
        setPaymentModal(false);
        setVacatingNoticeModal(false);
        setWarningModal(false);
        setRecallReasonModal(false);
        setRecallReason("");
    };

    // Format amount based on status
    const getFormattedWalletBalance = () => {
        if (tenantDetails.get("status") !== "COMPLETED") {
            return parseInt("0").toLocaleString("en-US", {
                style: "currency",
                currency: "KSH",
            });
        } else {
            return parseInt(
                tenantDetails.get("Wallet")?.toString().replace(",", "") || "0"
            ).toLocaleString("en-US", {
                style: "currency",
                currency: "KSH",
            });
        }
    };

    return (
        <>
            {backDrop}

            {/* Warning Dialog */}
            <Dialog
                open={warningModal}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
                    }
                }}
            >
                <DialogTitle
                    style={{
                        color: "#3A5A78",
                        borderBottom: '1px solid #eaeaea',
                        padding: '20px 24px',
                        fontSize: '18px',
                        fontWeight: 600
                    }}
                >
                    Warning
                </DialogTitle>
                <DialogContent sx={{padding: '24px'}}>
                    <DialogContentText id="alert-dialog-slide-description">
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                gap: "16px"
                            }}
                        >
                            <Warning
                                style={{
                                    fontSize: 40,
                                    color: "#F59E0B",
                                }}
                            />
                            <div style={{fontSize: '15px', lineHeight: '1.5'}}>
                                {vacatingWarningModalNotice}
                            </div>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{padding: '16px 24px'}}>
                    <LoadingButton
                        onClick={() => {
                            handleClose();
                            sendVacatingNoticeAfterWarning();
                        }}
                        loading={tenantLoading}
                        style={{
                            color: "#10B981",
                            fontWeight: 500,
                            textTransform: 'none'
                        }}
                    >
                        Proceed
                    </LoadingButton>
                    <Button
                        onClick={handleClose}
                        style={{
                            color: "#EF4444",
                            fontWeight: 500,
                            textTransform: 'none'
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            {/* NEW: Recall Reason Dialog */}
            <Dialog
                open={recallReasonModal}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="recall-reason-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                        minWidth: '400px'
                    }
                }}
            >
                <DialogTitle
                    style={{
                        color: "#3A5A78",
                        borderBottom: '1px solid #eaeaea',
                        padding: '20px 24px',
                        fontSize: '18px',
                        fontWeight: 600,
                        textAlign: 'center'
                    }}
                >
                    📝 Recall Vacating Notice
                </DialogTitle>
                <DialogContent sx={{padding: '24px'}}>
                    <DialogContentText sx={{marginBottom: '16px', color: '#6B7280'}}>
                        Please provide a reason for recalling your vacating notice. This will be recorded for management review.
                    </DialogContentText>

                    <TextField
                        autoFocus
                        fullWidth
                        multiline
                        rows={4}
                        label="Reason for Recall"
                        placeholder="e.g., Change of plans, found alternative accommodation, family circumstances..."
                        value={recallReason}
                        onChange={(e) => setRecallReason(e.target.value)}
                        variant="outlined"
                        InputLabelProps={{
                            style: { color: '#3A5A78' }
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                            }
                        }}
                    />

                    <div style={{
                        marginTop: '16px',
                        padding: '12px',
                        backgroundColor: '#FEF3C7',
                        borderRadius: '8px',
                        border: '1px solid #F59E0B',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <Info style={{ color: '#D97706', fontSize: '20px' }} />
                        <span style={{ fontSize: '14px', color: '#92400E' }}>
                            Note: Recalling a notice may affect your deposit refund eligibility depending on timing and circumstances.
                        </span>
                    </div>
                </DialogContent>

                <DialogActions sx={{padding: '16px 24px'}}>
                    <Button
                        onClick={handleClose}
                        style={{
                            color: "#6B7280",
                            fontWeight: 500,
                            textTransform: 'none'
                        }}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        onClick={handleRecallReasonSubmit}
                        loading={tenantLoading}
                        startIcon={<Delete />}
                        loadingPosition="start"
                        style={{
                            color: "white",
                            backgroundColor: "#EF4444",
                            textTransform: 'none',
                            padding: '8px 16px',
                            borderRadius: '6px'
                        }}
                    >
                        Recall Notice
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            {detailsSet && (
                <>
                    {/* Payment Dialog */}
                    <Dialog
                        open={paymentModal}
                        TransitionComponent={Transition}
                        keepMounted
                        aria-describedby="payment-dialog-description"
                        PaperProps={{
                            style: {
                                borderRadius: '12px',
                                boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
                            }
                        }}
                    >
                        <DialogTitle
                            style={{
                                color: "#3A5A78",
                                borderBottom: '1px solid #eaeaea',
                                padding: '20px 24px',
                                fontSize: '18px',
                                fontWeight: 600
                            }}
                        >
                            Make Payment
                        </DialogTitle>
                        <DialogContent sx={{padding: '24px'}}>
                            <DialogContentText id="payment-dialog-description">
                                <Formik
                                    initialValues={initialPaymentValues}
                                    validationSchema={basicSchema}
                                    onSubmit={processPayment}
                                >
                                    {(props) => (
                                        <Form noValidate>
                                            <p style={{marginBottom: '16px', color: '#4B5563'}}>
                                                Enter number to be prompted to make payment
                                            </p>
                                            <Field
                                                as={TextField}
                                                name="phone_number"
                                                label="Phone Number"
                                                error={
                                                    props.errors.phone_number &&
                                                    props.touched.phone_number
                                                }
                                                helperText={
                                                    <ErrorMessage className="error" name="phone_number"/>
                                                }
                                                required
                                                variant="outlined"
                                                style={{marginTop: "16px", width: "100%"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                            <Field
                                                as={TextField}
                                                name="amount"
                                                label="Amount"
                                                type="number"
                                                required
                                                variant="outlined"
                                                error={props.errors.amount && props.touched.amount}
                                                helperText={
                                                    <ErrorMessage className="error" name="amount"/>
                                                }
                                                style={{marginTop: "16px", width: "100%"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />

                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    marginTop: "24px",
                                                    gap: "12px"
                                                }}
                                            >
                                                <Button
                                                    onClick={handleClose}
                                                    style={{
                                                        color: "#EF4444",
                                                        fontWeight: 500,
                                                        textTransform: 'none'
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                                <LoadingButton
                                                    type="submit"
                                                    size="medium"
                                                    loading={tenantLoading}
                                                    startIcon={<Send/>}
                                                    style={{
                                                        color: "white",
                                                        backgroundColor: "#3A5A78",
                                                        textTransform: 'none',
                                                        padding: '8px 16px',
                                                        borderRadius: '6px'
                                                    }}
                                                    loadingPosition="start"
                                                >
                                                    Submit
                                                </LoadingButton>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>

                    {/* Vacating Notice Dialog */}
                    <Dialog
                        maxWidth="md"
                        open={vacatingNoticeModal}
                        TransitionComponent={Transition}
                        keepMounted
                        aria-describedby="vacating-notice-dialog-description"
                        PaperProps={{
                            style: {
                                borderRadius: '12px',
                                boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
                            }
                        }}
                    >
                        <DialogTitle
                            style={{
                                color: "#3A5A78",
                                borderBottom: '1px solid #eaeaea',
                                padding: '20px 24px',
                                fontSize: '18px',
                                fontWeight: 600,
                                textAlign: 'center'
                            }}
                        >
                            Vacating Notice
                        </DialogTitle>
                        <DialogContent
                            style={{
                                padding: '24px',
                            }}
                        >
                            <Formik
                                initialValues={initialValues2}
                                validationSchema={dateSchema}
                                onSubmit={sendVacatingNotice}
                            >
                                {(props) => (
                                    <Form noValidate>
                                        {/* Checklist Section */}
                                        <div style={{
                                            backgroundColor: '#F8FAFC',
                                            borderRadius: '8px',
                                            padding: '20px',
                                            marginBottom: '24px',
                                            border: '1px solid #E2E8F0'
                                        }}>
                                            <h4 style={{
                                                margin: '0 0 16px 0',
                                                color: '#3A5A78',
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                <Info style={{fontSize: '20px'}}/>
                                                Vacating Requirements Checklist
                                            </h4>

                                            <div style={{
                                                maxHeight: '300px',
                                                overflowY: 'auto',
                                                paddingRight: '8px'
                                            }}>
                                                {getVacatingChecklist().map((item) => (
                                                    <div key={item.id} style={{
                                                        display: 'flex',
                                                        alignItems: 'flex-start',
                                                        gap: '12px',
                                                        marginBottom: '16px',
                                                        padding: '12px',
                                                        backgroundColor: 'white',
                                                        borderRadius: '6px',
                                                        border: `1px solid ${
                                                            item.status === 'failed' ? '#FEE2E2' :
                                                                item.status === 'warning' ? '#FEF3C7' :
                                                                    item.status === 'passed' ? '#D1FAE5' : '#E5E7EB'
                                                        }`
                                                    }}>
                                                        {item.status === 'passed' && (
                                                            <CheckCircle style={{
                                                                color: '#10B981',
                                                                fontSize: '20px',
                                                                marginTop: '2px'
                                                            }}/>
                                                        )}
                                                        {item.status === 'failed' && (
                                                            <Cancel style={{
                                                                color: '#EF4444',
                                                                fontSize: '20px',
                                                                marginTop: '2px'
                                                            }}/>
                                                        )}
                                                        {item.status === 'warning' && (
                                                            <Warning style={{
                                                                color: '#F59E0B',
                                                                fontSize: '20px',
                                                                marginTop: '2px'
                                                            }}/>
                                                        )}
                                                        {item.status === 'info' && (
                                                            <Info style={{
                                                                color: '#3B82F6',
                                                                fontSize: '20px',
                                                                marginTop: '2px'
                                                            }}/>
                                                        )}

                                                        <div style={{flex: 1}}>
                                                            <div style={{
                                                                fontWeight: 600,
                                                                fontSize: '14px',
                                                                color: '#374151',
                                                                marginBottom: '4px'
                                                            }}>
                                                                {item.title}
                                                            </div>
                                                            <div style={{
                                                                fontSize: '13px',
                                                                color: '#6B7280',
                                                                marginBottom: item.risk ? '6px' : 0
                                                            }}>
                                                                {item.description}
                                                            </div>
                                                            {item.risk && (
                                                                <div style={{
                                                                    fontSize: '12px',
                                                                    color: item.status === 'failed' ? '#DC2626' : '#D97706',
                                                                    fontWeight: 500,
                                                                    fontStyle: 'italic'
                                                                }}>
                                                                    ⚠️ {item.risk}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: "16px",
                                                flexWrap: "wrap"
                                            }}
                                        >
                                            <Field
                                                as={TextField}
                                                name="first_name"
                                                label="First Name"
                                                variant="outlined"
                                                error={
                                                    props.errors.first_name && props.touched.first_name
                                                }
                                                helperText={
                                                    <ErrorMessage className="error" name="first_name"/>
                                                }
                                                required
                                                disabled={true}
                                                style={{marginTop: "16px", width: "calc(33.33% - 11px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                            <Field
                                                as={TextField}
                                                name="last_name"
                                                label="Last Name"
                                                error={
                                                    props.errors.last_name && props.touched.last_name
                                                }
                                                helperText={
                                                    <ErrorMessage className="error" name="last_name"/>
                                                }
                                                required
                                                variant="outlined"
                                                disabled={true}
                                                style={{marginTop: "16px", width: "calc(33.33% - 11px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                            <Field
                                                as={TextField}
                                                name="national_id"
                                                label="National ID"
                                                type="number"
                                                required
                                                variant="outlined"
                                                disabled={true}
                                                style={{marginTop: "16px", width: "calc(33.33% - 11px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: "16px"
                                            }}
                                        >
                                            <Field
                                                as={TextField}
                                                name="phone_number"
                                                label="Phone Number"
                                                error={
                                                    props.errors.phone_number &&
                                                    props.touched.phone_number
                                                }
                                                className={
                                                    props.errors.phone_number &&
                                                    props.touched.phone_number
                                                        ? "input-error"
                                                        : ""
                                                }
                                                helperText={
                                                    <ErrorMessage className="error" name="phone_number"/>
                                                }
                                                required
                                                variant="outlined"
                                                style={{marginTop: "16px", width: "calc(50% - 8px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                            <Field
                                                as={TextField}
                                                name="unit"
                                                label="House Number"
                                                error={props.errors.unit && props.touched.unit}
                                                helperText={
                                                    <ErrorMessage className="error" name="unit"/>
                                                }
                                                required
                                                disabled={true}
                                                variant="outlined"
                                                style={{marginTop: "16px", width: "calc(50% - 8px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: "16px"
                                            }}
                                        >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    disabled={true}
                                                    value={dateToday}
                                                    onChange={() => {
                                                    }}
                                                    label="Date Today"
                                                    inputFormat="MM/DD/YYYY"
                                                    renderInput={(params) => (
                                                        <TextField
                                                            name="date_notice_given"
                                                            error={
                                                                props.errors.date_notice_given &&
                                                                props.touched.date_notice_given
                                                            }
                                                            helperText={
                                                                <ErrorMessage
                                                                    className="error"
                                                                    name="date_notice_given"
                                                                />
                                                            }
                                                            style={{marginTop: "16px", width: "calc(50% - 8px)"}}
                                                            {...params}
                                                            InputLabelProps={{
                                                                style: {color: '#3A5A78'}
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    label="Date To Vacate"
                                                    inputFormat="MM/DD/YYYY"
                                                    value={dateToVacate}
                                                    onChange={(newValue) => setDateToVacate(newValue)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            name="date_to_vacate_House"
                                                            error={
                                                                props.errors.date_to_vacate_House &&
                                                                props.touched.date_to_vacate_House
                                                            }
                                                            helperText={
                                                                <ErrorMessage
                                                                    className="error"
                                                                    name="date_notice_given"
                                                                />
                                                            }
                                                            style={{marginTop: "16px", width: "calc(50% - 8px)"}}
                                                            {...params}
                                                            InputLabelProps={{
                                                                style: {color: '#3A5A78'}
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        </div>

                                        <div
                                            style={{
                                                marginTop: "24px",
                                            }}
                                        >
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '8px',
                                                color: '#3A5A78',
                                                fontWeight: 500
                                            }}>
                                                Reason for Vacating
                                            </label>
                                            <RichTextEditor
                                                richTextValue={editorState}
                                                change={(value) => {
                                                    setEditorState(value);
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                width: "100%",
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                marginTop: "24px",
                                                gap: "12px"
                                            }}
                                        >
                                            <Button
                                                onClick={handleClose}
                                                style={{
                                                    color: "#EF4444",
                                                    fontWeight: 500,
                                                    textTransform: 'none'
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                            <LoadingButton
                                                type="submit"
                                                size="medium"
                                                loading={tenantLoading}
                                                startIcon={<Send/>}
                                                style={{
                                                    color: "white",
                                                    backgroundColor: "#3A5A78",
                                                    textTransform: 'none',
                                                    padding: '8px 16px',
                                                    borderRadius: '6px'
                                                }}
                                                loadingPosition="start"
                                            >
                                                Submit
                                            </LoadingButton>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </DialogContent>
                    </Dialog>
                </>
            )}

            {/* Main Dashboard Cards */}
            <div style={{
                fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif"
            }}>
                {/* Top Row Cards */}
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '24px',
                    marginBottom: '24px'
                }}>
                    {/* Wallet Balance Card */}
                    <div style={{
                        flex: '1',
                        backgroundColor: '#F0FDF4',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                        border: '1px solid #D1FAE5',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '16px'
                        }}>
                            <h3 style={{
                                margin: 0,
                                color: '#065F46',
                                fontSize: '16px',
                                fontWeight: 600
                            }}>
                                Wallet Balance
                            </h3>
                            <AccountBalanceWallet style={{color: '#059669'}}/>
                        </div>

                        <HtmlTooltip title="Account Balance">
                            <p style={{
                                fontSize: '24px',
                                fontWeight: 700,
                                margin: '0 0 16px 0',
                                color: '#065F46'
                            }}>
                                {getFormattedWalletBalance()}
                            </p>
                        </HtmlTooltip>

                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            padding: '6px 0',
                            color: '#059669',
                            fontWeight: 500,
                            fontSize: '14px'
                        }} onClick={() => {
                            setPaymentModal(true);
                        }}>
                            <span>Deposit</span>
                            <Payment style={{marginLeft: '8px', fontSize: '18px'}}/>
                        </div>
                    </div>

                    {/* Property Card */}
                    <div style={{
                        flex: '1',
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                        border: '1px solid #E5E7EB',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '16px'
                        }}>
                            <h3 style={{
                                margin: 0,
                                color: '#3A5A78',
                                fontSize: '16px',
                                fontWeight: 600
                            }}>
                                Property
                            </h3>
                            <Apartment style={{color: '#3B82F6'}}/>
                        </div>

                        <p style={{
                            fontSize: '24px',
                            fontWeight: 700,
                            margin: '0 0 16px 0',
                            color: '#3A5A78'
                        }}>
                            {tenantDetails.get("property_name")}
                        </p>

                        <div style={{
                            fontSize: '14px',
                            color: '#6B7280'
                        }}>
                            Unit {tenantDetails.get("house_number")}
                        </div>
                    </div>

                    {/* Rent Agreed Card */}
                    <div style={{
                        flex: '1',
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                        border: '1px solid #E5E7EB',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '16px'
                        }}>
                            <h3 style={{
                                margin: 0,
                                color: '#3A5A78',
                                fontSize: '16px',
                                fontWeight: 600
                            }}>
                                Rent Agreed
                            </h3>
                        </div>

                        <p style={{
                            fontSize: '24px',
                            fontWeight: 700,
                            margin: '0 0 16px 0',
                            color: '#3A5A78'
                        }}>
                            {tenantDetails.get("rent")?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "KSH",
                            })}
                        </p>

                        <div style={{
                            fontSize: '14px',
                            color: '#6B7280'
                        }}>
                            Rent Is Due By 5<sup>th</sup>
                        </div>
                    </div>
                </div>

                {/* Bottom Row Cards */}
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '24px'
                }}>
                    {/* Pending Bill Card */}
                    {tenantDetails.get("status") !== "COMPLETED" ? (
                        <motion.div
                            animate={{scale: [0.98, 1, 0.98]}}
                            transition={{duration: 3, repeat: Infinity}}
                            style={{
                                flex: '1',
                                backgroundColor: '#FEF2F2',
                                borderRadius: '12px',
                                padding: '24px',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                                border: '1px solid #FEE2E2',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <h3 style={{
                                    margin: 0,
                                    color: '#991B1B',
                                    fontSize: '16px',
                                    fontWeight: 600
                                }}>
                                    Pending Bill
                                </h3>
                            </div>

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                flexDirection: 'column',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <p style={{
                                    fontSize: '24px',
                                    fontWeight: 700,
                                    margin: 0,
                                    color: '#991B1B'
                                }}>
                                    {parseInt(
                                        tenantDetails.get("Wallet")?.toString().replace(",", "") || "0"
                                    ).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "KSH",
                                    })}
                                </p>

                                <Button
                                    style={{
                                        background: '#EF4444',
                                        color: 'white',
                                        textTransform: 'none',
                                        padding: '8px 16px',
                                        borderRadius: '6px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        fontWeight: 500
                                    }}
                                    onClick={() => {
                                        setPaymentModal(true);
                                    }}
                                >
                                    Pay Now
                                    <Payment
                                        style={{
                                            marginLeft: '6px',
                                            fontSize: '20px'
                                        }}
                                    />
                                </Button>
                            </div>

                            <div style={{
                                fontSize: '14px',
                                color: '#B91C1C'
                            }}>
                                Pay On Time To Avoid Penalties
                            </div>
                        </motion.div>
                    ) : (
                        <div style={{
                            flex: '1',
                            backgroundColor: '#F0FDF4',
                            borderRadius: '12px',
                            padding: '24px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                            border: '1px solid #D1FAE5',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <h3 style={{
                                    margin: 0,
                                    color: '#065F46',
                                    fontSize: '16px',
                                    fontWeight: 600
                                }}>
                                    Pending Bill
                                </h3>
                            </div>

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <p style={{
                                    fontSize: '24px',
                                    fontWeight: 700,
                                    margin: 0,
                                    color: '#065F46'
                                }}>
                                    {parseInt(
                                        "0".toString().replace(",", "") || "0"
                                    ).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "KSH",
                                    })}
                                </p>

                                <Button
                                    style={{
                                        background: '#10B981',
                                        color: 'white',
                                        textTransform: 'none',
                                        padding: '8px 16px',
                                        borderRadius: '6px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        fontWeight: 500
                                    }}
                                    onClick={() => {
                                        setPaymentModal(true);
                                    }}
                                >
                                    Pay Now
                                    <Payment
                                        style={{
                                            marginLeft: '6px',
                                            fontSize: '20px'
                                        }}
                                    />
                                </Button>
                            </div>

                            <div style={{
                                fontSize: '14px',
                                color: '#059669'
                            }}>
                                All Bills Cleared
                            </div>
                        </div>
                    )}

                    {/* Notice Card - Updated with Recall functionality */}
                    {tenantDetails.get("state") === "NOTICE" ? (
                        <motion.div
                            animate={{scale: [0.98, 1, 0.98]}}
                            transition={{duration: 3, repeat: Infinity}}
                            style={{
                                flex: '1',
                                backgroundColor: '#EFF6FF',
                                borderRadius: '12px',
                                padding: '24px',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                                border: '1px solid #DBEAFE',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <h3 style={{
                                    margin: 0,
                                    color: '#1E40AF',
                                    fontSize: '16px',
                                    fontWeight: 600
                                }}>
                                    Available Notice
                                </h3>
                                <Assignment style={{color: '#3B82F6'}}/>
                            </div>

                            <p style={{
                                fontSize: '16px',
                                fontWeight: 500,
                                margin: '0 0 16px 0',
                                color: '#1E40AF'
                            }}>
                                You requested to vacate on:{" "}
                                <span style={{fontWeight: 700}}>
                  {new Map(
                      Object.entries(tenantDetails.get("notice") || {})
                  ).get("date_to_vacate_house")}
                </span>
                            </p>

                            <div style={{
                                fontSize: '14px',
                                color: '#3B82F6',
                                marginBottom: '16px'
                            }}>
                                Date notice given:{" "}
                                {new Map(Object.entries(tenantDetails.get("notice") || {})).get(
                                    "date_created"
                                )}
                            </div>

                            <LoadingButton
                                onClick={handleRecallNoticeClick}
                                loading={tenantLoading}
                                startIcon={<Delete/>}
                                style={{
                                    background: '#EF4444',
                                    color: 'white',
                                    textTransform: 'none',
                                    padding: '8px 16px',
                                    borderRadius: '6px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    fontWeight: 500,
                                    alignSelf: 'flex-start'
                                }}
                                loadingPosition="start"
                            >
                                Recall Notice
                            </LoadingButton>
                        </motion.div>
                    ) : (
                        <div style={{
                            flex: '1',
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: '24px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                            border: '1px solid #E5E7EB',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <h3 style={{
                                    margin: 0,
                                    color: '#3A5A78',
                                    fontSize: '16px',
                                    fontWeight: 600
                                }}>
                                    Notice
                                </h3>
                                <Assignment style={{color: '#3B82F6'}}/>
                            </div>

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <p style={{
                                    fontSize: '16px',
                                    fontWeight: 500,
                                    margin: 0,
                                    color: '#3A5A78'
                                }}>
                                    Vacating Notice
                                </p>

                                <Button
                                    style={{
                                        background: '#3B82F6',
                                        color: 'white',
                                        textTransform: 'none',
                                        padding: '8px 16px',
                                        borderRadius: '6px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        fontWeight: 500
                                    }}
                                    onClick={() => {
                                        setVacatingNoticeModal(true);
                                    }}
                                >
                                    Fill Form
                                    <Assignment
                                        style={{
                                            marginLeft: '6px',
                                            fontSize: '20px'
                                        }}
                                    />
                                </Button>
                            </div>

                            <div style={{
                                fontSize: '14px',
                                color: '#6B7280'
                            }}>
                                Ts & Cs Apply
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}